import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { Observable } from 'rxjs';
import { SectionAnchorBannerData } from '@fcp/lib-ui';
import { AnchorBannerContainerService } from './anchor-banner-container.service';

@Component({
  selector: 'fcp-anchor-banner-container',
  template: `
    <fcp-section-anchor-banner
      [sectionAnchorBanner]="sectionAnchorBanner | async"
      (wasButtonClicked)="wasButtonClicked.emit($event)"
    >
    </fcp-section-anchor-banner>
  `
})
export class AnchorBannerContainerComponent implements OnInit {
  @Output() public wasButtonClicked: EventEmitter<any> = new EventEmitter();
  @Input() private id: string;
  public sectionAnchorBanner: Observable<SectionAnchorBannerData>;

  constructor(
    private anchorBannerContainerService: AnchorBannerContainerService
  ) {}

  ngOnInit() {
    this.sectionAnchorBanner = this.anchorBannerContainerService.getDestaqueNavegacao(
      this.id
    );
  }
}
